import React, { useState } from 'react';
import './About.css';
import clinicaConfig from "../../clinicaConfig.js";
import equip from "../../Components/Assets/equipe.jpeg";
import maquina from "../../Components/Assets/mac1.jpeg";
import equipe1 from "../../Components/Assets/equipe1.jpeg";
import fotosSamec1 from "../../Components/Assets/fotosSamec (1).jpeg";
import fotosSamec3 from "../../Components/Assets/fotosSamec (3).jpeg";
import fotosSamec4 from "../../Components/Assets/fotosSamec (4).jpeg";
import fotosSamec5 from "../../Components/Assets/fotosSamec (5).jpeg";
import fotosSamec6 from "../../Components/Assets/fotosSamec (6).jpeg";
import fotosSamec7 from "../../Components/Assets/fotosSamec (7).jpeg";
import fotosSamec8 from "../../Components/Assets/fotosSamec (8).jpeg";

import pacienteDefault from "../Assets/padrao.svg";

import { 
  FaWhatsapp, FaCheckCircle, FaMapMarkerAlt, 
  FaUserMd, FaPercent, FaHome, FaBullseye, 
  FaEye, FaGem, FaMicroscope
} from 'react-icons/fa';

function About() {
  const [expandedReviews, setExpandedReviews] = useState({});

  const galeriaSamec = [
    { src: fotosSamec1, alt: "Estrutura SAMEC 1" },
    { src: maquina, alt: "Equipamento SAMEC mac1" },
    { src: fotosSamec3, alt: "Estrutura SAMEC 3" },
    { src: fotosSamec4, alt: "Estrutura SAMEC 4" },
    { src: equipe1, alt: "Equipe SAMEC 1" },
    { src: fotosSamec5, alt: "Estrutura SAMEC 5" },
    { src: fotosSamec6, alt: "Estrutura SAMEC 6" },
    { src: fotosSamec7, alt: "Estrutura SAMEC 7" },
    { src: fotosSamec8, alt: "Estrutura SAMEC 8" }
  ];

  const avaliacoesGoogle = [
    {
      nome: "Marcos Alberto Mendonça",
      texto: "Fui muito bem atendido, Simplesmente a melhor da Região"
    },
    {
      nome: "Joao Paulo Jesus",
      texto: "Excelente atendimento na Clínica Samec! Equipe muito profissional, ambiente moderno e agilidade nos exames. O cuidado e a atenção com o paciente fazem toda a diferença. Super recomendo!"
    },
    {
      nome: "Neto Barbosa",
      texto: "Tive uma experiência muito positiva na Clínica SAMEC. O atendimento foi organizado desde a recepção até a consulta, com profissionais atenciosos e explicações claras durante todo o processo. A estrutura é bem cuidada e transmite confiança, o que faz diferença principalmente para quem busca resolver tudo em um só lugar. Considero uma ótima opção, tanto pela variedade de especialidades quanto pela forma respeitosa como tratam os pacientes. Recomendo!"
    }
  ];

  const toggleReview = (index) => {
    setExpandedReviews((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <section className="about-page">
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>Sobre a {clinicaConfig.nomeClinica}</h1>
          <h2>Diagnósticos precisos. Atendimento humano. Tecnologia que cuida.</h2>
          <p>
            Unimos excelência técnica, inovação e cuidado para oferecer uma experiência
            de saúde mais simples, segura e eficiente.
          </p>
        </div>
      </div>

      <div className="about-container">
        <div className="mission-grid">
          <div className="mission-card">
            <div className="card-icon-styled"><FaBullseye /></div>
            <h3>Missão</h3>
            <p>
              Entregar diagnósticos confiáveis com agilidade, tecnologia e atenção
              genuína às pessoas.
            </p>
          </div>

          <div className="mission-card">
            <div className="card-icon-styled"><FaEye /></div>
            <h3>Visão</h3>
            <p>
              Ser referência regional em qualidade, inovação e experiência do paciente.
            </p>
          </div>

          <div className="mission-card">
            <div className="card-icon-styled"><FaGem /></div>
            <h3>Valores</h3>
            <p>
              Ética, precisão, transparência, empatia e compromisso real com cada paciente.
            </p>
          </div>
        </div>

        <div className="info-section-premium">
          <div className="info-content-split">
            <div className="info-visual">
              <img src={equip} alt="Equipe especializada" className="large-featured-img" />
            </div>
            <div className="info-text-box">
              <span className="info-tag"><FaUserMd /> Corpo Clínico</span>
              <h3>Especialistas que fazem a diferença</h3>
              <p>
                Nossa equipe é formada por profissionais experientes e em constante
                atualização. Atuamos de forma integrada para garantir segurança,
                precisão nos resultados e um atendimento verdadeiramente humano.
              </p>
            </div>
          </div>
        </div>

        <div className="info-section-premium">
          <div className="info-content-split reverse">
            <div className="info-visual">
              <div className="tech-display-grid-premium">
                {galeriaSamec.map((foto, index) => (
                  <div
                    key={`${foto.alt}-${index}`}
                    className={`tech-photo-card tech-photo-${index + 1}`}
                  >
                    <img src={foto.src} alt={foto.alt} />
                  </div>
                ))}
              </div>
            </div>
            <div className="info-text-box">
              <span className="info-tag"><FaMicroscope /> Tecnologia</span>
              <h3>Estrutura moderna e inovação constante</h3>
              <p>
                Investimos continuamente em equipamentos de última geração e em uma
                infraestrutura planejada para oferecer mais conforto, agilidade e
                diagnósticos altamente precisos.
              </p>
            </div>
          </div>
        </div>

        <div className="why-us-modern">
          <div className="why-us-header">
            <h2>Por que escolher a {clinicaConfig.nomeClinica}?</h2>
            <p>Compromisso com qualidade, eficiência e cuidado em cada detalhe.</p>
          </div>

          <div className="benefits-grid-modern">
            <div className="benefit-card-new">
              <FaCheckCircle className="b-icon" />
              <span>Resultados ágeis e confiáveis</span>
            </div>

            <div className="benefit-card-new">
              <FaUserMd className="b-icon" />
              <span>Equipe qualificada</span>
            </div>

            <div className="benefit-card-new">
              <FaWhatsapp className="b-icon" />
              <span>Agendamento rápido pelo WhatsApp</span>
            </div>

            <div className="benefit-card-new">
              <FaPercent className="b-icon" />
              <span>Condições acessíveis</span>
            </div>

            <div className="benefit-card-new">
              <FaHome className="b-icon" />
              <span>Coleta domiciliar</span>
            </div>

            <div className="benefit-card-new">
              <FaMapMarkerAlt className="b-icon" />
              <span>Localização estratégica</span>
            </div>
          </div>
        </div>

        <div className="testimonials-section">
          <h3>Avaliações recentes no Google</h3>

          <div className="testimonials-grid">
            {avaliacoesGoogle.map((avaliacao, index) => {
              const expanded = !!expandedReviews[index];
              const hasToggle = avaliacao.texto.length > 150;

              return (
                <div className="testimonial-card" key={`${avaliacao.nome}-${index}`}>
                  <p className={`testimonial-text ${hasToggle && !expanded ? 'collapsed' : 'expanded'}`}>
                    "{avaliacao.texto}"
                  </p>

                  {hasToggle && (
                    <button
                      type="button"
                      className="testimonial-toggle"
                      onClick={() => toggleReview(index)}
                    >
                      {expanded ? 'Ver menos' : 'Ver mais'}
                    </button>
                  )}

                  <div className="testimonial-user">
                    <img src={pacienteDefault} alt={avaliacao.nome} />
                    <div>
                      <h4>{avaliacao.nome}</h4>
                      <span>Avaliação no Google</span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="about-cta-final">
          <div className="cta-card">
            <h2>Cuidar da sua saúde pode ser simples.</h2>
            <p>Agende seus exames de forma rápida, prática e segura.</p>
            <button 
              className="cta-button-main" 
              onClick={() => window.open(`https://wa.me/${clinicaConfig.whatsapp}`, '_blank')}
            >
              <FaWhatsapp /> Fale conosco pelo WhatsApp
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
